import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" id=\"icon-more\">\r\n  <circle cx=\"12\" cy=\"12\" r=\"1\" />\r\n  <circle cx=\"12\" cy=\"5\" r=\"1\" />\r\n  <circle cx=\"12\" cy=\"19\" r=\"1\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol